import { render } from "./editproduct.vue?vue&type=template&id=01cadac2&scoped=true"
import script from "./editproduct.vue?vue&type=script&lang=js"
export * from "./editproduct.vue?vue&type=script&lang=js"

import "./editproduct.vue?vue&type=style&index=0&id=01cadac2&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cadac2"]])

export default __exports__